import {mouseMoving} from "./helpers/mouse-moving.js";

export const products = ()=> {

    const productSections = document.querySelectorAll('.products')

    productSections?.forEach(section=> {

        const wrapper = section.querySelector('.products__wrapper')
        const bgElement = section.querySelector('.products__bg-element')
        const bottlesElement = section.querySelector('.products__bottles-element')

        if (wrapper) {
            mouseMoving(wrapper,bgElement,0.33,3)
            mouseMoving(wrapper,bottlesElement,0.80,1.5)
        }

        addEventListener('resize',()=> {
            if (wrapper) {
                mouseMoving(wrapper,bgElement,0.33,3)
                mouseMoving(wrapper,bottlesElement,0.80,1.5)
            }
        })
    })


}